import { useMutation } from '@tanstack/react-query';
import { exportAccommodationsToExcel } from '../api/accommodation.api';
import { AccommodationSearchParams } from '../types/accomodation.types';
import { toast } from '@/hooks/use-toast';

export const useAccommodationExport = () => {
  const mutation = useMutation({
    mutationFn: async (data: AccommodationSearchParams) => {
      const response = await exportAccommodationsToExcel(data);
      return response.data;
    },
    onSuccess: (data) => {
      // Crear un blob y descargar el archivo
      const blob = new Blob([data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'alojamientos.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast({
        title: "Descarga completada",
        description: "El archivo Excel se ha descargado exitosamente.",
        variant: "default",
      });
    },
    onError: (error: any) => {
      console.error("Error al exportar Excel:", error);
      toast({
        title: "Error al exportar",
        description: error?.response?.data?.message || "Ocurrió un error al generar el archivo Excel.",
        variant: "destructive",
      });
    },
  });

  return {
    exportToExcel: mutation.mutate,
    isExporting: mutation.isPending,
    error: mutation.error,
  };
}; 